import { computed, Injectable, signal } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private loadingMap = new Map<string, boolean>();
  isLoading = new Subject<boolean>();

  load(name: string) {
    this.loadingMap.set(name, true);
    this.isLoading.next(true);
  }

  done(name: string) {
    this.loadingMap.delete(name);
    this.isLoading.next(Array.from(this.loadingMap.entries()).length > 0);
  }
}
